import { useState } from "react";
import { api, formatError } from "../lib/api";
import { PageHeader, Modal } from "../components/ui-kit";
import { useAuth } from "../lib/auth";
import { KeyRound } from "lucide-react";

export default function ProfilePage() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr("");
    if (form.new_password !== form.confirm) { setErr("As senhas não coincidem"); return; }
    if (form.new_password.length < 8) { setErr("Nova senha precisa ter pelo menos 8 caracteres"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      setMsg("Senha alterada com sucesso.");
      setForm({ current_password: "", new_password: "", confirm: "" });
      setOpen(false);
    } catch (e) { setErr(formatError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="profile-page">
      <PageHeader eyebrow="Conta" title="Meu Perfil" />

      <div className="card p-6 max-w-2xl">
        <div className="grid grid-cols-2 gap-6 mb-6">
          <Field label="Nome" value={user?.name} />
          <Field label="Perfil" value={user?.role} />
          <Field label="Email" value={user?.email} />
          <Field label="Usuário" value={user?.username || "-"} />
        </div>

        {msg && <div className="mb-3 p-2 text-sm border" style={{ background: "rgba(34,197,94,0.08)", borderColor: "rgba(34,197,94,0.3)", color: "#86EFAC" }}>{msg}</div>}
        <button className="btn btn-primary" onClick={() => { setErr(""); setMsg(""); setOpen(true); }} data-testid="open-change-password-btn">
          <KeyRound size={14} /> Alterar minha senha
        </button>
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="Alterar senha" testid="change-password-modal"
        footer={<>
          <button className="btn btn-secondary" onClick={() => setOpen(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={submit} disabled={loading} data-testid="save-change-password">Salvar</button>
        </>}>
        {err && <div className="mb-3 p-2 text-sm border" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }}>{err}</div>}
        <form onSubmit={submit} className="grid gap-3">
          <div><label className="label-caps block mb-1">Senha atual</label>
            <input className="input" type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required data-testid="cp-current" />
          </div>
          <div><label className="label-caps block mb-1">Nova senha</label>
            <input className="input" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required data-testid="cp-new" />
          </div>
          <div><label className="label-caps block mb-1">Confirmar nova senha</label>
            <input className="input" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required data-testid="cp-confirm" />
          </div>
        </form>
      </Modal>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <div className="label-caps mb-1">{label}</div>
      <div className="text-sm">{value}</div>
    </div>
  );
}
